
module.exports = {"attributes":{"width":"36","height":"23","viewBox":"0 0 36 23"},"content":"<path d=\"M3.2 0l-3.2 3.3v16.4l3.3 3.3h18.7v-23h-18.8m30.4 1l-8.6 8v5l8.6 8h2.4v-21h-2.4\"/>"}
var desvg = require('@kossnocorp/desvg/react')
module.exports = desvg(module.exports)
